import React, { useContext, useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';
import { Space, Table, Tag, Button } from 'antd';

import { numberFormatter } from '../../../components/formatters/numberFormatter';




const LoadRecieptJv = (props) => {

    const { setTransactions, journalVoucher, selectedCurrency } = props;

    const { api, userData, settingData, mainCurrency, secondaryCurrency, rateMainToSecondaryCurrency, rateToMainCurrency } = useContext(DataContext);
    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role;



    // load Transactions
    useEffect(() => {
        loadJV();
    }, [journalVoucher]);

    const accountId = journalVoucher?.accountId;
    const warehouseId = journalVoucher?.warehouseId;
    const cashAccountId = journalVoucher.cashAccountId;
    const isDebit = journalVoucher.isDebit;

    const downPayment = journalVoucher.downPayment;

    const rate = selectedCurrency?.rate;
    const currencyId = selectedCurrency?.id;
    const total = journalVoucher?.debit;

    const loadJV = () => {

        let updatedTransactions = [];

        updatedTransactions = loadAcountTransaction(updatedTransactions, true, cashAccountId, 'Accounts Payable', total);
        updatedTransactions = loadAcountTransaction(updatedTransactions, false, accountId, 'Customer', total);

        setTransactions(updatedTransactions);

    }


    const loadAcountTransaction = (updatedTransactions, isDebit, accountId, type, total) => {


        const debit = isDebit ? total : 0;
        const credit = !isDebit ? total : 0;

        const totalDebit = rateToMainCurrency(selectedCurrency, debit);
        const totalCredit = rateToMainCurrency(selectedCurrency, credit);

        const secondaryTotalDebit = rateMainToSecondaryCurrency(totalDebit);
        const secondaryTotalCredit = rateMainToSecondaryCurrency(totalCredit);

        const accountTransaction = {
            type: type,
            accountId: accountId,
            details: '',
            isDebit: isDebit,
            debit: debit,
            credit: credit,
            totalDebit: totalDebit,
            totalCredit: totalCredit,
            secondaryTotalDebit: secondaryTotalDebit,
            secondaryTotalCredit: secondaryTotalCredit,
            currencyId: currencyId,
            rate: rate,
        }

        updatedTransactions.push(accountTransaction);

        return updatedTransactions;
    }


    return (


        <></>

    )
}


export default LoadRecieptJv;